import React from 'react';

import UserIcon from "../../../../../gd-components/icons/user/user-icon-deprecated";

type Props = {
    option              : Option
    isHighlighted       : boolean
    isSelected          : boolean

    onClick             : callback
}

// extends React.Component is required because of reference in parent
export default class FieldDropdown_PopoverOptionUser extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    onClick = () => {
        this.props.onClick(this.props.option)
    }

    render() {

        const classes = Classes("option", "with-icon-26", {
            "highlighted"   : this.props.isHighlighted,
            "selected"      : this.props.isSelected
        })

        const iconClass = Classes("ico", this.props.option.icon)

        return (
            <div className={classes} onClick={this.onClick}>

                {this.props.option.icon &&
                    <div className={iconClass}/>
                }

                {!this.props.option.icon &&
                <>
                    {!this.props.option.value && <div className="ico i5-user"/>}
                    {this.props.option.value &&
                        <div className="ico">
                            <UserIcon userId={this.props.option.value} hint={false} size="26"/>
                        </div>}
                </>
                }

                <div className="label">
                    {this.props.option.label}
                </div>
            </div>
        )
    }
}
